import {
  SET_USER,
  SET_LOGGED,
  SET_AGENDA,
  SET_NUM_SUPERPING,
  SET_NOTE,
  //CHANGE_INFO,
  CHANGE_RESEARCH_INFO,
  CHANGE_PERSONAL_INFO,
  CHANGE_CURR_COND,
  CHANGE_PERSONAL_ELEMENTS,
  CHANGE_TENANTS_NUMBER,
  //CHANGE_TENANT,
  CHANGE_IMAGE,
  CHANGE_COVER_IMAGE,
  CHANGE_VIDEO,
  CHANGE_TEMPLATE,
  CHANGE_SETTINGS,
  SET_HELP_SEEN,
  SET_INVITE_HELP_SEEN,
  SET_PING_HELP_SEEN,
  SET_SUPERPING_HELP_SEEN,
  SET_SHARE_HELP_SEEN,
  SET_NEW_USER,
  SET_TEMP_HOME,
  ADD_TEMP_PHOTO,
  ADD_TEMP_PHOTO_LOADER,
  REMOVE_TEMP_PHOTO_PLACEHOLDER,
  SET_PROFILATION,
} from "@/constants/action-user-types";

import type {
  IUser,
  IAgendaEntry,
  ITenant,
  IMessengerContact,
  IWhatsappContact,
} from "@/types";

// Types for action payloads
interface ResearchElements {
  seeking?: boolean;
  city?: string;
  budget?: number;
  from_date?: string;
  to_date?: string;
  alone?: boolean;
  tenants?: ITenant[];
  zone?: string[];
  room_types?: string[];
}

interface PersonalElements {
  weekend?: number;
  sport?: number;
  alcol?: number;
  smoke?: number;
  animals?: number;
}

interface PersonalInfo {
  relationship?: number;
  education?: number;
  description?: string;
  location?: string;
}

interface CurrentCondition {
  type?: string;
  studyplace?: string;
  workplace?: string;
}

interface ImagePayload {
  profile_image?: string;
  profile_image_webp?: string;
}

interface CoverImagePayload {
  cover_image?: string;
  cover_image_webp?: string;
}

interface SettingsPayload {
  name?: string;
  surname?: string;
  mail?: string;
  active?: boolean;
  subscribed?: boolean;
  subscribedBasic?: boolean;
  seeking?: boolean;
  birth?: number;
  gender?: string;
  city?: string;
  terms?: boolean;
  profiled?: boolean;
  marketing?: boolean;
  email_disabled?: boolean;
  isNotifMailConfirmed?: boolean;
  whatsappContact?: IWhatsappContact;
  messengerContact?: IMessengerContact;
  instagramContact?: string;
  tiktokContact?: string;
  telegramContact?: string;
}

interface HelpSeenPayload {
  pwaInstallSeen?: boolean;
  preBookingSeen?: boolean;
  inviteHelpSeen?: boolean;
  pingHelpSeen?: boolean;
  superpingHelpSeen?: boolean;
  shareHelpSeen?: boolean;
}

interface ProfilationPayload {
  profiled?: boolean;
  description?: string;
  location?: string;
  budget?: number;
  from_date?: string;
  to_date?: string;
  room_types?: string[];
  education?: number;
  relationship?: number;
  sport?: number;
  weekend?: number;
  alcol?: number;
  smoke?: number;
  animals?: number;
  coliving?: { [key: string]: number };
  studyplace?: string;
  workplace?: string;
  interests?: string[];
  type?: string;
  lifestyles?: string[];
}

// Action creators
export const setUser = (user: IUser & { logged: boolean }) =>
  ({ type: SET_USER, payload: user } as const);
//export const userChangeInfoElements = infoElements => ({ type: CHANGE_INFO, payload: infoElements});
export const userChangeResearchElements = (
  researchElements: ResearchElements
) =>
  ({
    type: CHANGE_RESEARCH_INFO,
    payload: researchElements,
  } as const);

export const setLogged = (logged: { logged: boolean }) =>
  ({
    type: SET_LOGGED,
    payload: logged,
  } as const);

export const setAgenda = (entries: IAgendaEntry[]) =>
  ({
    type: SET_AGENDA,
    payload: entries,
  } as const);

export const setNumSuperping = (num: number) =>
  ({
    type: SET_NUM_SUPERPING,
    payload: num,
  } as const);

export const setNote = (entry: IAgendaEntry) =>
  ({
    type: SET_NOTE,
    payload: entry,
  } as const);

export const userChangePersonalElements = (elements: PersonalElements) =>
  ({
    type: CHANGE_PERSONAL_ELEMENTS,
    payload: elements,
  } as const);

export const userChangePersonalInfo = (info: PersonalInfo) =>
  ({
    type: CHANGE_PERSONAL_INFO,
    payload: info,
  } as const);
export const userChangeCurrentCondition = (condition: CurrentCondition) =>
  ({
    type: CHANGE_CURR_COND,
    payload: condition,
  } as const);

export const userChangeTenantsNumber = (index: number) =>
  ({
    type: CHANGE_TENANTS_NUMBER,
    payload: index,
  } as const);

//export const userChangeTenants = (gender,type,age,id) => ({ type: CHANGE_TENANT, payload: {gender,type,age,id} });
export const userChangeImage = (
  profile_image: string,
  profile_image_webp: string
) =>
  ({
    type: CHANGE_IMAGE,
    payload: { profile_image, profile_image_webp },
  } as const);

export const userChangeCoverImage = (
  cover_image: string,
  cover_image_webp: string
) =>
  ({
    type: CHANGE_COVER_IMAGE,
    payload: { cover_image, cover_image_webp },
  } as const);

export const userChangeVideo = (videoId: string) =>
  ({
    type: CHANGE_VIDEO,
    payload: videoId,
  } as const);

export const userChangeTemplate = (template: string) =>
  ({
    type: CHANGE_TEMPLATE,
    payload: template,
  } as const);

export const userSettings = (settings: SettingsPayload) =>
  ({
    type: CHANGE_SETTINGS,
    payload: settings,
  } as const);

export const userHelpSeen = (helpSeen: HelpSeenPayload) =>
  ({
    type: SET_HELP_SEEN,
    payload: helpSeen,
  } as const);

export const userInviteHelpSeen = (bool: boolean) =>
  ({
    type: SET_INVITE_HELP_SEEN,
    payload: bool,
  } as const);

export const userPingHelpSeen = (bool: boolean) =>
  ({
    type: SET_PING_HELP_SEEN,
    payload: bool,
  } as const);

export const userSuperpingHelpSeen = (bool: boolean) =>
  ({
    type: SET_SUPERPING_HELP_SEEN,
    payload: bool,
  } as const);

export const userShareHelpSeen = (bool: boolean) =>
  ({
    type: SET_SHARE_HELP_SEEN,
    payload: bool,
  } as const);

export const userSetNew = (bool: boolean) =>
  ({
    type: SET_NEW_USER,
    payload: bool,
  } as const);

export const userSetTempHome = (tempHome: any) =>
  ({
    type: SET_TEMP_HOME,
    payload: tempHome,
  } as const);

// Atomic tempHome.photo_array mutations. These let the reducer operate on the
// latest state so concurrent uploads can't clobber each other's placeholders.
export const userAddTempPhoto = (photo: any) =>
  ({
    type: ADD_TEMP_PHOTO,
    payload: photo,
  } as const);

export const userAddTempPhotoLoader = (length: number) =>
  ({
    type: ADD_TEMP_PHOTO_LOADER,
    payload: length,
  } as const);

export const userRemoveTempPhotoPlaceholder = () =>
  ({
    type: REMOVE_TEMP_PHOTO_PLACEHOLDER,
    payload: null,
  } as const);

export const userSetProfilation = (user: ProfilationPayload) =>
  ({
    type: SET_PROFILATION,
    payload: user,
  } as const);
